// import utils from '../utils/index'
import axios from '@/utils/request'
var Qs = require('qs')

export default {
    // 2020-11-07
    search(params) {
        return axios.get('/reminders?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
    },
    // 2020-10--27
    insertBatch(params) {
        return axios.post('/reminders/insert-batch', params)
    },
    // 2020-11-28
    reminderCount() {
        return axios.get('/reminders/reminder-count')
    },
    // 2020-12-12
    read(id) {
        return axios.put('/reminders/' + id + '/read')
    },
    // 2020-12-19
    receiverCount() {
        return axios.get('/reminders/receiver-count ')
    }
}

